"use client";

import LazyLoaded from "@/components/LazyLoaded";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import dynamic from "next/dynamic";

const SetOverviewSignupPopup = dynamic(() => import("./SetOverviewSignupPopup"));

const SetOverviewWithSignupPopup = () => {
    const { user } = useCurrentUser();
    const trigger = useScrollTrigger({ threshold: 750, disableHysteresis: true });

    if (user) {
        return null;
    }

    return (
        <LazyLoaded load={trigger}>
            <SetOverviewSignupPopup isOpen={trigger} />
        </LazyLoaded>
    );
};

export default SetOverviewWithSignupPopup;
